import { FC } from "react";
import { Box, IconButton } from "@mui/material";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { CountriesGridMenu } from "../countries/menu";
import { CountryMenu } from "../country/menu";
import { RequestNewCountryMenu } from "../requestNew/menu";
import { MyCountryRequestsMenu } from "../myRequests/menu";

type Props = {};

export const CountriesMenu: FC<Props> = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isOverview = /^\/countries\/?$/.test(location.pathname);

  const nav = () => (isOverview ? navigate("/home") : navigate("/countries"));

  return (
    <Box display="flex" width="100%">
      <IconButton onClick={nav} sx={{ color: "secondary.main" }}>
        <ArrowBackIcon />
      </IconButton>
      <Box display="flex" alignItems="center" width="100%">
        <Routes>
          <Route path="country/:id/*" element={<CountryMenu />} />
          <Route path="request-new" element={<RequestNewCountryMenu />} />
          <Route path="my-requests" element={<MyCountryRequestsMenu />} />
          <Route path="*" element={<CountriesGridMenu />} />
        </Routes>
      </Box>
    </Box>
  );
};
